import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { deprecate } from 'react-is-deprecated';
import { StarRating } from 'reaxl';
function RatingBreakdown(_ref) {
  let {
    className,
    layout = 'stacked',
    modalView,
    // deprecated
    maxRatingValue = 5,
    ratings,
    ...rest
  } = _ref;
  // handle deprecated prop
  if (modalView) {
    layout = 'horizontal';
  }
  const isHorizontal = layout === 'horizontal';
  return ratings?.length > 0 && /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx('row', className)
  }, rest), ratings.map(function (_temp, index) {
    let {
      name,
      value
    } = _temp === void 0 ? {} : _temp;
    const isEven = index % 2 === 0;
    return /*#__PURE__*/_jsx("div", {
      className: clsx(isHorizontal ? 'col-md-6' : 'col-xs-6')
    }, `ratingBreakdownWrapper-${name}`, /*#__PURE__*/_jsx("div", {
      className: clsx('row margin-top-1 display-flex align-items-baseline ', {
        'margin-bottom-2': isHorizontal,
        'flex-wrap margin-bottom-3': !isHorizontal
      })
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: clsx({
        'col-md-offset-1': isHorizontal && !isEven,
        'col-xs-12': !isHorizontal,
        'col-xs-5 col-sm-5 col-md-4': isHorizontal
      })
    }, void 0, name), /*#__PURE__*/_jsx("div", {
      className: clsx({
        'col-xs-12': !isHorizontal,
        'col-xs-7 col-sm-7 col-md-8': isHorizontal
      })
    }, void 0, /*#__PURE__*/_jsx(StarRating, {
      className: "text-size-500",
      color: "#e8bb38",
      showRating: true,
      value: value,
      uiContext: "five-stars"
    }))));
  }));
}
export default /*#__PURE__*/memo(RatingBreakdown);